import 'reflect-metadata';
import { Container } from 'inversify';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import {
  ApiService,
  AuthService,
  CommentService,
  ConstructionService,
  CookieService,
  ContactService,
  CustomerService,
  NewCustomerService,
  DeliveryService,
  HttpService,
  ListService,
  MapService,
  SearchService,
  TaskService,
  TeamService,
  UserService,
  CascadeService,
  ProductService,
  OrganizerService,
  OrganizerMockService,
  UserProfileService,
  SignalsService,
  SignalsMockService,
  PromiseService,
} from 'services';

export const container = new Container();
container.bind(SERVICE_IDENTIFIER.ApiService).to(ApiService).inSingletonScope();
container.bind(SERVICE_IDENTIFIER.ConstructionService).to(ConstructionService);
container.bind(SERVICE_IDENTIFIER.AuthService).to(AuthService);
container.bind(SERVICE_IDENTIFIER.CommentService).to(CommentService);
container.bind(SERVICE_IDENTIFIER.CookieService).to(CookieService);
container.bind(SERVICE_IDENTIFIER.ContactService).to(ContactService);
container.bind(SERVICE_IDENTIFIER.CustomerService).to(CustomerService);
container.bind(SERVICE_IDENTIFIER.NewCustomerService).to(NewCustomerService);
container.bind(SERVICE_IDENTIFIER.HttpService).to(HttpService);
container.bind(SERVICE_IDENTIFIER.ListService).to(ListService);
container.bind(SERVICE_IDENTIFIER.DeliveryService).to(DeliveryService);
container.bind(SERVICE_IDENTIFIER.MapService).to(MapService);
container.bind(SERVICE_IDENTIFIER.ProductService).to(ProductService);
container.bind(SERVICE_IDENTIFIER.SearchService).to(SearchService);
container.bind(SERVICE_IDENTIFIER.TaskService).to(TaskService);
container.bind(SERVICE_IDENTIFIER.TeamService).to(TeamService);
container.bind(SERVICE_IDENTIFIER.UserService).to(UserService);
container.bind(SERVICE_IDENTIFIER.CascadeService).to(CascadeService);
container.bind(SERVICE_IDENTIFIER.OrganizerService).to(OrganizerService);
container.bind(SERVICE_IDENTIFIER.OrganizerMockService).to(OrganizerMockService);
container.bind(SERVICE_IDENTIFIER.UserProfileService).to(UserProfileService);
container.bind(SERVICE_IDENTIFIER.SignalsService).to(SignalsService);
container.bind(SERVICE_IDENTIFIER.SignalsMockService).to(SignalsMockService);
container.bind(SERVICE_IDENTIFIER.PromiseService).to(PromiseService);

export const apiService = container.get(SERVICE_IDENTIFIER.ApiService);
export const authService = container.get(SERVICE_IDENTIFIER.AuthService);
export const commentService = container.get(SERVICE_IDENTIFIER.CommentService);
export const constructionService = container.get(SERVICE_IDENTIFIER.ConstructionService);
export const cookieService = container.get(SERVICE_IDENTIFIER.CookieService);
export const contactService = container.get(SERVICE_IDENTIFIER.ContactService);
export const customerService = container.get(SERVICE_IDENTIFIER.CustomerService);
export const newCustomerService = container.get(SERVICE_IDENTIFIER.NewCustomerService);
export const deliveryService = container.get(SERVICE_IDENTIFIER.DeliveryService);
export const httpService = container.get(SERVICE_IDENTIFIER.HttpService);
export const listService = container.get(SERVICE_IDENTIFIER.ListService);
export const mapService = container.get(SERVICE_IDENTIFIER.MapService);
export const productService = container.get(SERVICE_IDENTIFIER.ProductService);
export const searchService = container.get(SERVICE_IDENTIFIER.SearchService);
export const taskService = container.get(SERVICE_IDENTIFIER.TaskService);
export const teamService = container.get(SERVICE_IDENTIFIER.TeamService);
export const userService = container.get(SERVICE_IDENTIFIER.UserService);
export const cascadeService = container.get(SERVICE_IDENTIFIER.CascadeService);
export const organizerService = container.get(SERVICE_IDENTIFIER.OrganizerService);
export const organizerMockService = container.get(SERVICE_IDENTIFIER.OrganizerMockService);
export const userProfileService = container.get(SERVICE_IDENTIFIER.UserProfileService);
export const signalsService = container.get(SERVICE_IDENTIFIER.SignalsService);
export const signalsMockService = container.get(SERVICE_IDENTIFIER.SignalsMockService);
export const promiseService = container.get(SERVICE_IDENTIFIER.PromiseService);
